import { render } from "./TargetAgreement.vue?vue&type=template&id=52250bed"
import script from "./TargetAgreement.vue?vue&type=script&lang=js"
export * from "./TargetAgreement.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Server-Testumgebung\\way-academy-app-main\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__